precision mediump float;

uniform sampler2D uPerlinTexture;
uniform float uTime;
uniform float uOpacity;
uniform float uTextureScale;
uniform vec3 uColorBottom; // red-ish
uniform vec3 uColorTop;    // yellow-ish
uniform float alphaParam;

varying vec2 vUv;
varying float vHeight;

void main() {
    vec3 col = mix(uColorBottom, uColorTop, vHeight) * 20.0;
    float alpha = smoothstep(0.0, 0.2, vHeight) * (1.0 - vHeight) * uOpacity * alphaParam;
    gl_FragColor = vec4(col, alpha);
}

